// extracted by mini-css-extract-plugin
export default {"p":"styles_p__G6PLM","h":"styles_h__AU2X7"};